

export default function PjCard06() {


    return (
            <div>
               
                <img src="/assets/projects/qds/appmock.png" alt="qds website mockup"
                    loading="lazy"
                    style={{
                        position:'relative',
                        zIndex:'10',
                        width: "22em",
                        borderRadius: "1em",
                        
                    }} />
            </div>
    );
}
